import React, { Fragment, useEffect, useState } from "react";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import Scroll from "./components/Scroll";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { MacrosProvider } from "./utils/MacrosContext";
import { Outlet } from "react-router-dom";

//components
import Dashboard from "./components/dashboard/Dashboard";
import Login from "./components/Login";
import Register1 from "./components/RegistrationFlow/Register1";
import AllNotes from "./components/noteList/AllNotes";
import PageNotFound from "./components/PageNotFound";
import RecordPage from "./components/dashboard/RecordPage";
import SubscriptionPage from "./components/RegistrationFlow/SubscriptionPage";
import Settings from "./components/settings/Settings";
import Subscribe from "./components/Stripe/Checkout";
import UnsubscribeForm from "./components/UnsubscribeForm";

//this is to debug env variables
//console.log(process.env);
import LogRocket from "logrocket";

LogRocket.init("b0hpsh/knowtex-prod");

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(null);
  const [userId, setUserId] = useState(null);

  const setAuth = (boolean) => {
    setIsAuthenticated(boolean);
  };

  async function isAuth() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/is-verify`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );

      const parseRes = await response.json();
      parseRes === true ? setIsAuthenticated(true) : setIsAuthenticated(false);
      // if user authorized, update the log
      const decoded_token = jwt_decode(localStorage.token);
      const user_id = decoded_token["user"]["id"];
      setUserId(user_id);

      //log rocket
      LogRocket.identify(user_id);

      // Check subscription status
      const subscriptionResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/subscription-status`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );

      const subscriptionData = await subscriptionResponse.json();
      setIsSubscribed(subscriptionData.is_subscribed);
    } catch (err) {
      console.error("Authentication/Subscription check failed:", err.message);
    }
  }

  useEffect(() => {
    isAuth();
  }, [isSubscribed]);
  return (
    <Fragment>
      {isAuthenticated !== null && (
        <MacrosProvider>
          <Router>
            <Scroll />
            <Routes>
              {/* Public routes */}
              <Route
                exact
                path="/login"
                element={
                  !isAuthenticated ? (
                    <Login
                      setAuth={setAuth}
                      setIsSubscribed={setIsSubscribed}
                    />
                  ) : isSubscribed !== false ? (
                    <Navigate to="/dashboard" />
                  ) : (
                    <Navigate to="/subscription" />
                  )
                }
              />
              <Route
                exact
                path="/register"
                element={<Register1 setAuth={setAuth} />}
              />

              {/* Protected routes with MacrosProvider */}
              <Route
                element={
                  isAuthenticated ? <Outlet /> : <Navigate to="/login" />
                }
              >
                <Route
                  path="/dashboard"
                  element={
                    isSubscribed !== false ? (
                      <Dashboard
                        setAuth={setAuth}
                        setIsSubscribed={setIsSubscribed}
                        isSubscribed={isSubscribed}
                      />
                    ) : (
                      <Navigate to="/subscription" />
                    )
                  }
                />
                <Route
                  path="/notes"
                  element={
                    isSubscribed !== false ? (
                      <AllNotes
                        setAuth={setAuth}
                        setIsSubscribed={setIsSubscribed}
                        isSubscribed={isSubscribed}
                      />
                    ) : (
                      <Navigate to="/subscription" />
                    )
                  }
                />
                <Route
                  path="/record"
                  element={
                    isSubscribed !== false ? (
                      <RecordPage setAuth={setAuth} />
                    ) : (
                      <Navigate to="/subscription" />
                    )
                  }
                />
                <Route
                  path="/settings"
                  element={
                    isSubscribed !== false ? (
                      <Settings
                        setAuth={setAuth}
                        setIsSubscribed={setIsSubscribed}
                        isSubscribed={isSubscribed}
                      />
                    ) : (
                      <Navigate to="/subscription" />
                    )
                  }
                />
              </Route>

              {/* Other routes that don't need MacrosProvider */}
              <Route
                exact
                path="/"
                element={
                  !isAuthenticated ? (
                    <Login setAuth={setAuth} />
                  ) : !isSubscribed ? (
                    <Navigate to="/dashboard" />
                  ) : (
                    <Navigate to="/login" />
                  )
                }
              />
              <Route
                exact
                path="/subscription"
                element={
                  !isAuthenticated ? (
                    <Navigate to="/login" />
                  ) : isSubscribed !== false ? (
                    <Navigate to="/dashboard" />
                  ) : (
                    <SubscriptionPage setAuth={setAuth} />
                  )
                }
              />
              <Route
                exact
                path="/subscribe"
                element={
                  isAuthenticated ? (
                    isSubscribed !== false ? (
                      <Navigate to="/dashboard" />
                    ) : (
                      <Subscribe
                        setAuth={setAuth}
                        setIsSubscribed={setIsSubscribed}
                        isSubscribed={isSubscribed}
                      />
                    )
                  ) : (
                    <Navigate to="/login" />
                  )
                }
              />
              <Route
                exact
                path="/unsubscribe"
                element={
                  isAuthenticated ? (
                    isSubscribed ? (
                      <UnsubscribeForm />
                    ) : isSubscribed === null ? (
                      <Navigate to="/dashboard" />
                    ) : (
                      <Navigate to="/subscription" />
                    )
                  ) : (
                    <Navigate to="/login" />
                  )
                }
              />
              <Route exact path="*" element={<PageNotFound />} />
            </Routes>
          </Router>
        </MacrosProvider>
      )}
      <div>
        <ToastContainer />
      </div>
    </Fragment>
  );
}

export default App;
